/** Fuseau métier Clickorico (commerçants France). Helper Admin — pas d’import Website. */
const APP_TIMEZONE = 'Europe/Paris'

function toValidDate(value) {
  if (!value) return null
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date
}

function capitalizeFr(value) {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

function formatTimeH(date) {
  const raw = date.toLocaleTimeString('fr-FR', {
    timeZone: APP_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
  return String(raw).replace(':', 'h').replace(/\s/g, '')
}

/**
 * Date RDV Admin : « Samedi 22 août 2026 à 09h30 »
 * Jour de la semaine obligatoire ; année incluse par défaut.
 */
export function formatActionDateTimeFr(value, { includeYear = true } = {}) {
  const date = toValidDate(value)
  if (!date) return ''

  const weekday = capitalizeFr(
    date.toLocaleDateString('fr-FR', {
      timeZone: APP_TIMEZONE,
      weekday: 'long',
    }),
  )
  const dayMonth = date.toLocaleDateString('fr-FR', {
    timeZone: APP_TIMEZONE,
    day: 'numeric',
    month: 'long',
    ...(includeYear ? { year: 'numeric' } : {}),
  })
  return `${weekday} ${dayMonth} à ${formatTimeH(date)}`
}

/** Date seule : « Vendredi 9 octobre 2026 » (sans heure). */
export function formatActionDateOnlyFr(value, { includeYear = true } = {}) {
  const date = toValidDate(value)
  if (!date) return ''

  const weekday = capitalizeFr(
    date.toLocaleDateString('fr-FR', {
      timeZone: APP_TIMEZONE,
      weekday: 'long',
    }),
  )
  const dayMonth = date.toLocaleDateString('fr-FR', {
    timeZone: APP_TIMEZONE,
    day: 'numeric',
    month: 'long',
    ...(includeYear ? { year: 'numeric' } : {}),
  })
  return `${weekday} ${dayMonth}`
}
